import { useRouter } from 'next/router';
import { useContext } from 'react';
import { IsHomepageContext } from 'src/contexts/IsHomepageContext';
import { Pages } from 'src/types/pages';

export const useSkipToContent = () => {
    const { asPath } = useRouter();
    const isHomepage = useContext(IsHomepageContext);

    const handleSkipToContent = () => {
        if ((asPath as Pages).includes(Pages.myAccount)) {
            if (document.getElementsByClassName('details-link').length) {
                (document.getElementsByClassName('details-link')[0] as HTMLAnchorElement)?.focus();
                const y =
                    (document.getElementsByClassName('details-link')[0] as HTMLAnchorElement).getBoundingClientRect()
                        ?.top +
                    window.pageYOffset -
                    50;
                window.scrollTo({ top: y, behavior: 'smooth' });
            } else if (document.getElementsByClassName('view-all-details').length) {
                (document.getElementsByClassName('view-all-details')[0] as HTMLAnchorElement)?.focus();
                const y =
                    (
                        document.getElementsByClassName('view-all-details')[0] as HTMLAnchorElement
                    ).getBoundingClientRect()?.top +
                    window.pageYOffset -
                    50;
                window.scrollTo({ top: y, behavior: 'smooth' });
            }
        } else {
            const stockSlice = document.getElementById('skip-to-content');
            if (stockSlice) {
                switch (true) {
                    case isHomepage: {
                        (document.getElementsByClassName('carTitleWrap')[0]?.firstChild as HTMLAnchorElement)?.focus();
                        break;
                    }
                    case asPath.includes('/trim/stock'): {
                        (
                            document.getElementsByClassName('stockModelCard-dealerInfo--ctaSection')[0]
                                ?.firstChild as HTMLAnchorElement
                        )?.focus();
                        break;
                    }
                    case asPath.includes('/trim/configurable'): {
                        (document.getElementsByClassName('buttonWrapper')[0]?.firstChild as HTMLAnchorElement)?.focus();
                        break;
                    }
                    case asPath.includes('/selector/configurable'): {
                        (document.querySelectorAll('.engine')[0] as HTMLButtonElement)?.focus();
                        break;
                    }
                    case asPath.includes('/summary'): {
                        (document.getElementById('price-section') as HTMLButtonElement)?.focus();
                        break;
                    }
                    case asPath.includes('/basket'): {
                        if (document.getElementsByClassName('toggleOption').length) {
                            (document.getElementsByClassName('toggleOption')[0] as HTMLButtonElement)?.focus();
                        } else {
                            (document.getElementById('widgetView') as HTMLButtonElement)?.focus();
                        }
                        break;
                    }
                    default:
                        break;
                }
                const y = stockSlice?.getBoundingClientRect()?.top + window.pageYOffset - 50;
                window.scrollTo({ top: y, behavior: 'smooth' });
            }
        }
    };

    return { handleSkipToContent };
};
